import utils from '@/utils';
import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	getPopupPqyCpnys: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';
		if (searchParams.cpnyCd !== undefined) {
			queryStr = objectToQuerystring({
				cpnyCd: searchParams.cpnyCd,
				cpnyScn: searchParams.cpnyScn,
				useYn: searchParams.useYn,
				currentPage,
				pageUnit
			});
		}

		return client
			.get(`${BASE_URL}/comm/commpopup/pqyCpnyPopup/v1/cpnys` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
};
